import SimplePage from "@/components/structure/SimplePage";
import CohortUserMapping from "@/components/users/CohortUserMapping";

export default function About() {
  return (
    <SimplePage title="User Assignments">
      <CohortUserMapping />
    </SimplePage>
  );
}
